import React, { createContext, useContext, useState, useCallback } from 'react';
import CollabModal from '../projects/components/CollabModal';

// Create the context
const CollabModalContext = createContext();

/**
 * Provider component that manages the collaboration modal state
 */
export function CollabModalProvider({ children }) {
  const [isModalVisible, setIsModalVisible] = useState(false);

  const showCollabModal = useCallback(() => {
    setIsModalVisible(true);
  }, []);

  const hideCollabModal = useCallback(() => {
    setIsModalVisible(false);
  }, []);

  const value = {
    isModalVisible,
    showCollabModal,
    hideCollabModal,
  };

  return (
    <CollabModalContext.Provider value={value}>
      <>
      {children}
      <CollabModal
        show={isModalVisible}
        hideCollabModal={hideCollabModal}
      />
      </>
    </CollabModalContext.Provider>
  );
}

/**
 * Hook to use the collab modal context
 */
export function useCollabModal() {
  const context = useContext(CollabModalContext);
  if (!context) {
    throw new Error('useCollabModal must be used within a CollabModalProvider');
  }
  return context;
}

export default CollabModalContext;